import type { Sparte } from '@/features/Global/types';
import { pfeInventoryContractTransformers } from '@/features/Quotes/inventoryContractMappingDefinitions/pfe';
import type { LegacyInventoryContractTransformer } from '@/features/Quotes/types';

export const legacyInventoryContractTransformers: {
  [key in Sparte]?: LegacyInventoryContractTransformer;
} = {
  pfe: pfeInventoryContractTransformers,
};
